<template>
    <div 
        class="modal bg-black bg-opacity-75" 
        :class="{'show d-block': showModal}"
        @click.self="showModal = false"
    >
        <div class="modal-dialog modal-lg modal-dialog-centered m-0 m-sm-auto">
            <div 
                class="modal-content text-dark" 
                @click.stop
            > 
                <i 
                    class="position-absolute top-0 end-0 ms-auto m-3 bi bi-x-lg text-secondary-hover fs-5 fw-bold cursor-pointer zi-1" 
                    @click="showModal = false"
                />
                <div class="modal-body w-lg-75 w-100 mx-auto">
                    <ReportBugForm />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ReportBugForm from './ReportBugForm.vue';
export default {
    components: {
        ReportBugForm
    },
    props: {
        value: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        showModal: {
            get() {
                return this.value;
            },  
            set(value) {
                this.$emit('input', value);
            }
        }
    },
};
</script>